import { gatewayFetch } from "@Auth/session";
import { gatewayUrl } from "@Constants/gatewayUrl";
export function extensionOf(name) {
    const dot = name.lastIndexOf(".");
    return dot > 0 ? name.slice(dot + 1).toLowerCase() : "";
}
export async function uploadFile(file) {
    const contentType = file.type || "application/octet-stream";
    const subtype = extensionOf(file.name);
    const query = new URLSearchParams({
        contentType,
        fileType: subtype
    });
    const signed = await gatewayFetch(`${gatewayUrl}/generateUploadUrl?${query}`);
    if (!signed.ok) throw new Error(`Failed to sign upload: ${signed.status}`);
    const { path, preSigned } = await signed.json();
    const put = await fetch(preSigned, {
        method: "PUT",
        body: file,
        headers: {
            "Content-Type": contentType,
            "x-amz-acl": "public-read"
        }
    });
    if (!put.ok) throw new Error(`Failed to upload: ${put.status}`);
    const dot = file.name.lastIndexOf(".");
    return {
        link: path,
        filename: dot > 0 ? file.name.slice(0, dot) : file.name,
        subtype
    };
}
